<form [formGroup]="form" (ngSubmit)="addProtocol()">
    <div class="card-content">
        <div>
            <div class="full-width">
                <div class="card-inline">
                    <mat-form-field class="margin-right-small">
                        <input type="text" #newProtocol matInput placeholder="Protocolo" formControlName="NewProtocol">
                    </mat-form-field>
                    <button *ngIf="!loading" type="submit" mat-icon-button mat-mini-fab>
                <mat-icon>add</mat-icon>
              </button>
                </div>
                <mat-divider *ngIf="orderBatchItemsForm.controls.length > 0"></mat-divider>
                <mat-spinner *ngIf="loading"></mat-spinner>
                <table mat-table class="search-table margin-botton-medium" *ngIf="!loading && orderBatchItemsForm.controls.length > 0" [dataSource]="dataSource" formArrayName="OrderBatchItems">
                    <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayColumns"></tr>
                    <tr mat-row class="search-table-cell" *matRowDef="let row; let i = index; columns: displayColumns;"></tr>

                    <ng-container matColumnDef="Protocol">
                        <th mat-header-cell class="table-header" *matHeaderCellDef> Protocolo </th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            {{displayProtocol(index)}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="buttons">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index" (click)="$event.stopPropagation()">
                            <mat-icon class="cursor-default" (click)="deleteProtocol(index)">delete</mat-icon>
                        </td>
                    </ng-container>
                </table>
            </div>
        </div>
    </div>
</form>